import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const navLinks = [
  { to: '/', label: '首页', end: true },
  { to: '/category', label: '全部分类', end: false },
  ...categories.map((c) => ({
    to: `/category/${c.slug}`,
    label: c.name,
    end: false,
  })),
  { to: '/about', label: '关于我们', end: false },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-background-50 border-b border-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-[1280px] items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="看料99 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-display text-2xl leading-none text-foreground-950">看料99</span>
          <span className="hidden sm:inline-flex items-center rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
            首发爆料
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `inline-flex items-center rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <Link
            to="/#subscribe"
            className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 dark:text-foreground-950 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            订阅爆料
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    `block rounded-md px-3 py-2.5 text-sm transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700 font-medium'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/#subscribe"
            className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            订阅爆料
          </Link>
        </div>
      )}
    </header>
  );
}